import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Box, Button } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useTranslate } from "hooks/useTranslate";
import * as React from "react";
import { useDispatch } from "react-redux";
import { tokens } from "styles/Tokens";
import { checkUserAccess } from "utils/CommonFunctions";
import { setFeedbackDetails } from "./Snackbar/snackbar.slice";

const ITEM_HEIGHT = 48;

interface Props {
  disabled?: boolean;
  options?: any;
  value?: {};
  sx?: any;
  isDisabled?: boolean;
  label?: string;
}

export default function KebabMenu(props: Props) {
  const { disabled, options = [{ label: "" }], value, sx, isDisabled = false, label } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const translate = useTranslate();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!isDisabled) {
      event.stopPropagation();
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClose = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <>
      {label ? (
        <Button
          variant="outlined"
          disableRipple
          disabled={disabled}
          aria-label="more"
          id="long-button"
          aria-controls={open ? "long-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleClick}
          endIcon={<MoreVertIcon />}
          sx={{
            border: open ? `solid ${tokens.Border.General.Tertiary}` : "solid transparent",
            borderRadius: "8px",
            height: "34px",
            margin: 0,
            "&.MuiButtonBase-root:hover": {
              backgroundColor: "inherit",
              borderRadius: "8px",
              border: `solid ${tokens.Border.General.Tertiary}`,
              outline: "0"
            }
          }}
        >
          {label}
        </Button>
      ) : (
        <IconButton
          disableRipple
          disabled={disabled}
          aria-label="more"
          id="long-button"
          aria-controls={open ? "long-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleClick}
          sx={sx}
        >
          <MoreVertIcon />
        </IconButton>
      )}
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button"
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            marginY: "8px",
            borderRadius: "8px",
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "25ch",
            color: tokens.Text.General.PrimaryBody,
            fontVariant: "body2",
            "& .MuiMenuItem-root:hover": {
              backgroundColor: tokens.Background.General.Color,
              color: tokens.Text.General.Color,
              ".icon-svg": {
                stroke: tokens.Text.General.Color
              }
            }
          }
        }}
        disablePortal
      >
        {options?.map((option: any, index: number) => (
          <MenuItem
            sx={{
              height: "37px",
              "&.MuiMenuItem-root:hover": {
                backgroundColor: tokens.Background.General.Color
              }
            }}
            className={!checkUserAccess(option?.accessType) ? "disabled-menuitem" : ""}
            key={option.label}
            selected={option.label === "Pyxis"}
            disabled={checkUserAccess(option?.accessType) ? !option.enabled : false}
            onClick={(e: any) => {
              handleClose(e);
              if (!checkUserAccess(option.accessType))
                dispatch(
                  setFeedbackDetails({
                    shouldShow: true,
                    setState: setFeedbackDetails({ shouldShow: false }),
                    message: translate("user.restrictAccess")
                  })
                );
              else option?.action(value);
            }}
          >
            {option.icon && <option.icon />}
            <Box component={"span"} marginLeft="8px">
              {option?.label}
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
